<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let klass: string = "";
  export let value: {
    id: number;
    src: string;
    base64?: string;
  } = {
    id: 0,
    src: "",
    base64: null,
  };
  let fileInput;

  const dispatch = createEventDispatcher();

  function input(e) {
    dispatch("input", {
      value: e,
    });
  }

  const onFileSelected = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    let image = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = (e) => {
      value.base64 = e.target.result as string;
      input(value);
    };
  };
</script>

<div class={klass}>
  {#if value.base64 || value.src}
    <img
      class="selected-image"
      src={value.base64 || value.src}
      alt="画像の選択"
      on:click={fileInput.click()}
    />
  {:else}
    <div class="placeholder  bg-gray-200" on:click={fileInput.click()}>
      ファイルを選択
    </div>
  {/if}
  <input
    type="file"
    style="display: none;"
    accept="image/*"
    on:change={(e) => onFileSelected(e)}
    bind:this={fileInput}
  />
</div>

<style lang="postcss">
  .placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    height: 200px;
    cursor: pointer;
  }

  .selected-image {
    max-width: 400px;
    max-height: 400px;
    cursor: pointer;
  }
</style>
